import { useEffect, useRef } from "react";

const ORDERS = [
  { time: "1分钟前", name: "张**", status: "成功获取测试结果" },
  { time: "3分钟前", name: "李**", status: "成功获取测试结果" },
  { time: "5分钟前", name: "王*", status: "成功获取测试结果" },
  { time: "8分钟前", name: "刘**", status: "成功获取测试结果" },
  { time: "12分钟前", name: "陈**", status: "成功获取测试结果" },
  { time: "15分钟前", name: "杨*", status: "成功获取测试结果" },
  { time: "20分钟前", name: "赵**", status: "成功获取测试结果" },
  { time: "半小时前", name: "孙**", status: "成功获取测试结果" },
  { time: "1小时前", name: "周*", status: "成功获取测试结果" },
  { time: "2小时前", name: "吴**", status: "成功获取测试结果" },
  { time: "3小时前", name: "郑**", status: "成功获取测试结果" },
  { time: "5小时前", name: "冯**", status: "成功获取测试结果" },
  { time: "1天前", name: "蒋**", status: "成功获取测试结果" },
  { time: "1天前", name: "沈*", status: "成功获取测试结果" },
  { time: "2天前", name: "韩**", status: "成功获取测试结果" },
  { time: "2天前", name: "朱**", status: "成功获取测试结果" },
  { time: "3天前", name: "秦**", status: "成功获取测试结果" },
  { time: "3天前", name: "许**", status: "成功获取测试结果" },
  { time: "4天前", name: "何**", status: "成功获取测试结果" },
  { time: "5天前", name: "林**", status: "成功获取测试结果" },
];

// 复制一份实现无缝滚动
const DOUBLED = [...ORDERS, ...ORDERS];

export default function ScrollOrders() {
  const trackRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<number>(0);
  const posRef = useRef<number>(0);
  const ITEM_H = 36;
  const TOTAL_H = ORDERS.length * ITEM_H;

  useEffect(() => {
    let last = 0;
    const speed = 0.4; // px per ms * 16 ≈ 0.4px/frame

    const tick = (ts: number) => {
      if (last === 0) last = ts;
      const delta = ts - last;
      last = ts;
      posRef.current += speed * (delta / 16);
      if (posRef.current >= TOTAL_H) posRef.current -= TOTAL_H;
      if (trackRef.current) {
        trackRef.current.style.transform = `translateY(-${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(tick);
    };

    animRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animRef.current);
  }, [TOTAL_H]);

  return (
    <div
      className="w-full rounded-xl overflow-hidden"
      style={{
        background: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,220,120,0.25)",
        height: `${ITEM_H * 5}px`,
        position: "relative",
      }}
    >
      {/* 顶部渐变遮罩 */}
      <div
        className="absolute top-0 left-0 right-0 z-10 pointer-events-none"
        style={{
          height: "28px",
          background: "linear-gradient(to bottom, rgba(192,0,10,0.9), transparent)",
        }}
      />
      {/* 底部渐变遮罩 */}
      <div
        className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none"
        style={{
          height: "28px",
          background: "linear-gradient(to top, rgba(192,0,10,0.9), transparent)",
        }}
      />

      <div ref={trackRef} style={{ willChange: "transform" }}>
        {DOUBLED.map((order, i) => (
          <div
            key={i}
            className="flex items-center px-4"
            style={{ height: `${ITEM_H}px`, borderBottom: "1px solid rgba(255,220,120,0.1)" }}
          >
            <span className="text-xs flex-shrink-0" style={{ color: "rgba(255,220,180,0.55)", width: "72px" }}>
              {order.time}
            </span>
            <span className="text-xs font-semibold flex-1 text-center" style={{ color: "#ffd700" }}>
              {order.name}
            </span>
            <span className="text-xs flex-shrink-0" style={{ color: "rgba(255,220,180,0.8)" }}>
              {order.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
